export default __webpack_public_path__ + "static/media/success-tick.fc3e8e21.gif";